import React from "react";
import { DataGridPremium } from "@mui/x-data-grid-premium";

const DataTable = ({ rows, columns, loading }) => (
  <div
    style={{
      flexGrow: 1,
      height: "calc(100vh - 340px)", // dynamic height for full screen feel
      width: "100%",
      overflowX: "auto", // fixes scroll on smaller screens
    }}
  >
    <DataGridPremium
      rows={rows}
      columns={columns}
      loading={loading}
      disableRowSelectionOnClick
      showCellVerticalBorder={false}
      showColumnVerticalBorder={false}
      sx={{
        "& .MuiDataGrid-virtualScroller": {
          overflowX: "auto !important",
          overflowY: "auto !important",
        },
        "& .MuiDataGrid-cell": {
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
      }}
    />
  </div>
);

export default DataTable;
